import { useContext } from 'react';

import { SweetheartListContext } from '../SweetheartListContext';

const useSweetheartListContext = () => useContext(SweetheartListContext);

export default useSweetheartListContext;
